// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"0c2fd710","117":"93322ded","121":"a0e3a0c8","206":"3e6b7a28","235":"c67b7c77","280":"c835bb46","349":"2e8915a4","366":"8c748e73","452":"ff1b7949","555":"d100daaf","589":"41656171","698":"e9a61f20","788":"86f8216b","840":"aa7f03c5","921":"7647802e"}[chunkId] + ".chunk.js";
};